export const removeInitialAndFinalSlashs = (path) => {
  if (!path) return '';

  return path.replace(/^\s*\/*\s*|\s*\/*\s*$/gm, '');
};

export const getCurrentPath = () => {
  if (typeof window === 'undefined') return '';

  return removeInitialAndFinalSlashs(window?.location?.pathname);
};

export const getQueryParams = (href) => {
  if (typeof window === 'undefined' || !href) return '';

  const queryParams = window.location?.search || '';
  const queryParamsSeparator = href?.includes('?') ? '&' : '?';

  return queryParams ? `${queryParamsSeparator}${queryParams?.substring(1)}` : '';
};
